import React, { Component } from "react";
import { FormGroup } from "reactstrap";
import style from "./../../Order/Field/Field.module.scss";
import Holders from "../../Order/Field/Account/Holders";
import { Combobox, Field } from "../../Order/Field/Field";
import Autosuggest from "../../../Autosuggest/Autosuggest";
import CircularProgress from "../../../CircularProgress/CircularProgress";

class Account extends Component {
  constructor(props) {
    super(props);

    const { AccountId } = props;
    this.state = {
      loadingHolders: AccountId != null,
      holders: null,
    };
  }

  componentWillMount() {
    const { AccountId } = this.props;

    if (!this.props.hideHolder && AccountId != null) {
      this.requestAccountHolders({ AccountId });
    }
  }

  componentDidMount() {
    this._isMounted = true;
    const { AccountId, AccountName, AccountNumber, HolderId } = this.props;

    // Cuando se ve una orden ya viene precargados los valores
    if (!isEmpty(AccountId) && isEmpty(HolderId)) {
      this.onChange("", {
        id: AccountId,
        name: AccountName,
        number: AccountNumber,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onSuggestionsFetchRequested = ({ value }) => {
    const { sendingAccountId } = this.props;
    const { fetchSearchAccount, fetchSearchTransfer } = this.props.services;
    const filter = this.props.filter || [];
    if (sendingAccountId && sendingAccountId > 0) {
      return fetchSearchTransfer({
        text: value,
        sendingAccountId: sendingAccountId,
      })
        .then((r) => r.response.accounts)
        .then((accounts) =>
          accounts
            .map((a) => {
              const accountAttrs = JSON.parse(a.Value);

              return {
                id: a.Id,
                name: accountAttrs.value,
                number: accountAttrs.key,
              };
            })
            .filter((a) => !filter.includes(a.id))
        );
    } else {
      return fetchSearchAccount({ text: value })
        .then((r) => r.response.accounts)
        .then((accounts) =>
          accounts
            .map((a) => {
              const accountAttrs = JSON.parse(a.Value);

              return {
                id: a.Id,
                name: accountAttrs.value,
                number: accountAttrs.key,
              };
            })
            .filter((a) => !filter.includes(a.id))
        );
    }
  };

  renderSuggestion = (suggestion) => (
    <div className={style.suggestionItem}>{this.props.custody ? suggestion.name : suggestion.number}</div>
  );

  getSuggestionValue = (suggestion) => (this.props.custody ? `${suggestion.name}` : `${suggestion.number}`);

  onChangeAccountHolder = (value) => {
    const holderItem = getItemById(this.state.holders, value);

    this.props.onChange({
      HolderId: holderItem.id,
      HolderName: holderItem.description,
    });
  };

  requestAccountHolders = ({ AccountId }) => {
    const { fetchAccountHolders } = this.props.services;

    fetchAccountHolders({ accountId: AccountId })
      .then((r) => r.response.holders)
      .then((holders) => {
        let _holders = holders.map((h) => ({
          isMain: h.IsMain,
          description: h.PersonName,
          id: h.PersonId,
        }));

        const selectedHolder = _holders.find((h) => h.isMain) || (_holders.length ? _holders[0] : null);

        this._isMounted &&
          this.setState(
            {
              holders: _holders,
              loadingHolders: false,
            },
            () => {
              const { holderId } = this.props;

              if (holderId == null && selectedHolder) {
                const { id, description } = selectedHolder;

                this.props.onChange({
                  HolderId: id,
                  HolderName: description,
                });
              }
            }
          );
      });
  };

  onChange = (method, value) => {
    let _value = defaultAccountValue;

    if (method != "type" && value.id) {
      _value = {
        AccountNumber: value.number,
        AccountName: value.name,
        AccountId: value.id,
      };

      if (!this.props.hideHolder) {
        this.requestAccountHolders({ AccountId: value.id });
      }

      this.setState({ holders: null, loadingHolders: true });
    } else {
      this.setState({ holders: null });
      _value.AccountName = value;
    }

    this.props.onChange(_value);
  };

  render() {
    const { AccountName, AccountNumber, HolderId, HolderName, readonly, errors, hideHolder, label, custody } =
      this.props;

    const inputProps = {
      placeholder: "Account",
      disabled: readonly.AccountName,
      invalid: !!errors.AccountName,
    };

    return (
      <div>
        <FormGroup>
          <Field error={errors.AccountNumber}>
            <Autosuggest
              renderSuggestion={this.renderSuggestion}
              getSuggestionValue={this.getSuggestionValue}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              value={custody ? AccountName : String(AccountNumber)}
              inputProps={inputProps}
              onChange={this.onChange}
            />
          </Field>
        </FormGroup>

        {!hideHolder && (
          <React.Fragment>
            {this.state.loadingHolders ? (
              <CircularProgress sm />
            ) : (
              <div>
                <Field label={"Holder"} error={errors.HolderName}>
                  <Holders
                    name={HolderName}
                    value={HolderId}
                    items={this.state.holders}
                    disabled={readonly.HolderName || readonly.AccountName}
                    invalid={!!errors.HolderName}
                    onChange={this.onChangeAccountHolder}
                  />
                </Field>
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const defaultAccountValue = {
  AccountId: null,
  AccountName: "",
  HolderId: null,
  HolderName: null,
};

const getItemById = (items, id) => {
  return items.find((e) => e.id == id);
};

const isEmpty = (value) => value == undefined || value == "";

export default Account;
